module.exports = __webpack_public_path__ + "img/5.00255c7a.png";